document.addEventListener('DOMContentLoaded', function () {
  (function () {
    var links = document.links;
    for (let i = 0, linksLength = links.length; i < linksLength; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
      }
    }
  })();
});

document.addEventListener('DOMContentLoaded', function () {
  var checkoutButton = document.getElementById('checkout');
  var agreeCheckbox = document.getElementById('agree');
  var dynamicCheckoutButtons = document.querySelector('.cart__dynamic-checkout-buttons');

  if (checkoutButton && agreeCheckbox && dynamicCheckoutButtons) {
    // Set initial style based on checkbox state
    updateButtonAndDynamicCheckoutVisibility();

    checkoutButton.addEventListener('click', function (event) {
      if (!agreeCheckbox.checked) {
        alert("You must agree with the terms and conditions of sales to check out.");
        event.preventDefault();
      }
    });

    agreeCheckbox.addEventListener('change', updateButtonAndDynamicCheckoutVisibility);
  }

  function updateButtonAndDynamicCheckoutVisibility() {
    checkoutButton.style.display = agreeCheckbox.checked ? 'block' : 'none';
    dynamicCheckoutButtons.style.display = agreeCheckbox.checked ? 'block' : 'none';
    checkoutButton.disabled = !agreeCheckbox.checked;
  }
});

document.addEventListener('DOMContentLoaded', function() {
  function updateReservedFlag() {
    var urlParams = new URLSearchParams(window.location.search);
    var isReserved = urlParams.has('reserved') && urlParams.get('reserved') === 'true';

    // Ensure the element exists before trying to set its value
    var reservedFlagElement = document.getElementById('reserved_flag');
    var buyButtonsContainer = document.querySelector('.buy-buttons-container');
    var productDataElement = document.getElementById('product-data');
    var productMetafieldValue = productDataElement ? productDataElement.getAttribute('data-reserved-access') : null;
    var productMetafieldEnabled = productMetafieldValue === 'true';

    if (reservedFlagElement) {
      if (isReserved) {
        window.isReserved = true;  // Set a global flag
        reservedFlagElement.value = 'true'; // Set hidden input to true
      } else {
        window.isReserved = false;  // No reserved flag
        reservedFlagElement.value = 'false'; // Set hidden input to false
      }

      // Update the visibility of the buy buttons
      if (!productMetafieldEnabled || reservedFlagElement.value === 'true') {
        buyButtonsContainer.style.display = 'block';
      } else {
        buyButtonsContainer.style.display = 'none';
      }
    } else {
      console.error('Element with id "reserved_flag" not found.');
    }

    console.log(window.isReserved);  // Log the result to see if it's working
  }

  // Initial update on page load
  updateReservedFlag();

  // Listen for changes in the URL
  window.addEventListener('popstate', function() {
    updateReservedFlag();
  });
});
